import { AutocompleteInput, ReferenceInput, SelectInput, useGetMany, useListContext, usePermissions, useTranslate } from 'react-admin';
import FormDialog from '@/components/global/drawers/FormDialog.jsx';
import { serviceRequestStatusChoices } from '@/components/global/options/selectOptions.jsx';
import { userFilterToQuery } from '@/helpers/filters/filterToQuery.js';
import EditIcon from '@/assets/icons/edit-icon.svg?react';
import { Box } from '@mui/material';

export const ServiceBulkActionForm = () => {
    const { permissions } = usePermissions();
    const translate = useTranslate();
    const allStatusChoices = serviceRequestStatusChoices(translate);
    const statusChoices = (
        permissions.isService && !permissions.isServiceMaster && !permissions.isAdmin
            ? allStatusChoices.filter(choice => choice.id === 'inProgress' || choice.id === 'fixed')
            : allStatusChoices
    ).map(({ id, name }) => ({ id, name }));
    const { selectedIds, resource } = useListContext();
    const { data: selectedRecords = [], isLoading: isLoadingSelected } = useGetMany(resource, { ids: selectedIds }, { enabled: selectedIds?.length > 0 });
    const serviceCompanyIds = selectedRecords.map(record => record?.collectionPoint?.serviceCompanyId).filter(Boolean);
    const hasSingleCompany = serviceCompanyIds.length === selectedRecords.length && new Set(serviceCompanyIds).size === 1;
    const serviceCompanyId = hasSingleCompany ? serviceCompanyIds[0] : null;
    const isServicemanDisabled = isLoadingSelected || !hasSingleCompany;
    const servicemanHelperText =
        !isLoadingSelected && selectedIds?.length > 0 && !hasSingleCompany ? translate('resources.serviceRequest.labels.bulkServicemanDisabled') : undefined;
    const servicemanFilter = serviceCompanyId ? { role: 'ROLE_SERVICE', serviceCompanyId } : { role: 'ROLE_SERVICE' };

    return (
        <FormDialog title={translate('common.bulkEdit')} startIcon={<EditIcon />}>
            <SelectInput source='status' label={translate('common.status')} choices={statusChoices} fullWidth />
            {(permissions.isAdmin || permissions.isServiceMaster) && (
                <Box className='autocomplete-parent'>
                    <ReferenceInput source='servicemanId' reference='user' perPage={25} filter={servicemanFilter} enableGetChoices={() => !!serviceCompanyId}>
                        <AutocompleteInput
                            filterToQuery={userFilterToQuery}
                            optionText={choice => `${choice.firstName} ${choice.lastName}`}
                            label={translate('resources.serviceRequest.labels.serviceman')}
                            noOptionsText={translate('resources.serviceRequest.labels.noServiceman')}
                            fullWidth
                            disablePortal={true}
                            disabled={isServicemanDisabled}
                            helperText={servicemanHelperText}
                            isLoading={isLoadingSelected}
                        />
                    </ReferenceInput>
                </Box>
            )}
        </FormDialog>
    );
};
